import React from "react"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"
import {
  SplashScreen,
  OnboardScreen, OnboardTitle, OnboardLanguagePicker,
  SocialLoginScreen,
  LoginScreen,
  PasswordResetScreen,
  RegisterScreen,
  VerificationScreen,
  VerificationHeader,
  ScratchScreen,
} from "../../screens"
import { color } from "../../theme"
import { translate } from "../../i18n";

export type LoginNavigatorParamList = {
  'Login.Splash': undefined,
  'Login.Onboard': undefined,
  'Login.SocialLogin': undefined,
  'Login.Login': undefined,
  'Login.PasswordReset': undefined,
  'Login.Register': undefined,
  'Login.Verification': undefined,
  'Login.Scratch': undefined,
}

// const Stack = createNativeStackNavigator<LoginNavigatorParamList>()
const Stack = createStackNavigator<LoginNavigatorParamList>()

export const LoginStack = {
  index: 0,
  routes: [
    { name: 'Login.Stack', state: { index: 0, routes: [{ name: 'Login.Onboard' }] } }
  ]
};

export const LoginStackSplash = {
  index: 0,
  routes: [
    { name: 'Login.Stack', state: { index: 0, routes: [{ name: 'Login.Splash' }] } }
  ]
};

export const LoginStackVerification = {
  index: 0,
  routes: [
    { name: 'Login.Stack', state: { index: 0, routes: [{ name: 'Login.Verification' }] } }
  ]
}

export const LoginStackVerificationAfterLogin = {
  index: 0,
  routes: [
    { name: 'Login.Stack', state: { index: 0, routes: [{ name: 'Login.Verification', params: { hasLogin: 1 } }] } }
  ]
}

export const LoginStackScratch = {
  index: 0,
  routes: [
    { name: 'Login.Stack', state: { index: 0, routes: [{ name: 'Login.Scratch' }] } }
  ]
};

const HeaderTitle = () => (<OnboardTitle/>)
const HeaderRight = () => (<OnboardLanguagePicker/>)

export const LoginNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      initialRouteName="Login.Splash"
    >
      <Stack.Screen name="Login.Splash" component={SplashScreen} options={{ title: 'Splash' }} />
      <Stack.Screen
        name="Login.Onboard"
        component={OnboardScreen}
        options={{
          title: 'Onboard',
          headerTitle: HeaderTitle,
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.palette.white },
          headerTintColor: color.primary,
          headerRight: HeaderRight,
        }}
      />
      <Stack.Screen
        name="Login.SocialLogin"
        component={SocialLoginScreen}
        options={{
          title: 'Social Login',
          headerTitle: '',
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Login.Login"
        component={LoginScreen}
        options={{
          title: 'Login',
          headerTitle: '',
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Login.PasswordReset"
        component={PasswordResetScreen}
        options={{
          title: 'Password Reset',
          headerTitle: translate("passwordResetScreen.resetPassword"),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Login.Register"
        component={RegisterScreen}
        options={{
          title: 'Register',
          headerTitle: translate('onboardScreen.register'),
          headerShown: true,
          headerShadowVisible: true,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white
        }}
      />
      <Stack.Screen
        name="Login.Verification"
        component={VerificationScreen}
        options={({ navigation, route }) => ({
          title: 'Verification',
          headerTitle: '',
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header(props) {
            return <VerificationHeader navigation={navigation} route={route} />
          },
        })}
      />
      <Stack.Screen
       name="Login.Scratch"
       component={ScratchScreen}
       options={{
         headerTitle: "Scratch",
         headerShown: true,
         headerShadowVisible: true,
         headerStyle: { backgroundColor: color.primary },
         headerTintColor: color.palette.white,
       }}
      />
    </Stack.Navigator>
  )
}
